import { render, staticRenderFns } from "./selection.vue?vue&type=template&id=4d22ef26&scoped=true&"
import script from "./selection.vue?vue&type=script&lang=js&"
export * from "./selection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d22ef26",
  null
  
)

export default component.exports